import { ChangeDetectorRef, Component, OnDestroy, OnInit, SecurityContext } from '@angular/core';
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { IntlServicePP, LanguageAndManualSelect } from "../../intl/services/intl.service";
import { takeUntilDestroy } from "take-until-destroy";
import { AccessibilityStatementService } from "./accessibility.statement.service";
import { TranslateService } from "../../translate/services/translate.service";
import { MESSAGE_SUFFIX } from "../../translate/translate.suffix";
import { LogManager } from 'src/common/log/log.manager';
import { LogCat } from 'src/common/log/log.categories';
import { SelfSchedulingCommonService } from 'src/app-main/self.scheduling/services/self.scheduling.common.service';

@Component({
	selector: 'app-accessibility-statement-page',
	templateUrl: './accessibility.statement.page.template.html',
	styleUrls: ['./accessibility.statement.page.style.scss']
})
export class AccessibilityStatementPageComponent implements OnDestroy, OnInit {
	public statement: SafeHtml;

	constructor(private intlService: IntlServicePP, private accessibilityStatementService: AccessibilityStatementService,
		private domSanitizer: DomSanitizer, private translateService: TranslateService, private changeDetector: ChangeDetectorRef,
		private commonService: SelfSchedulingCommonService) {
	}

	ngOnInit(): void {
		this.intlService.getUsedLanguageObservable().pipe(takeUntilDestroy(this)).subscribe((language: LanguageAndManualSelect) => {
			this.accessibilityStatementService.getAccessibilityStatement(language.languageKey).pipe(takeUntilDestroy(this)).subscribe((statementString: string) => {
				this.statement = this.domSanitizer.sanitize(SecurityContext.HTML, statementString);
				this.changeDetector.markForCheck()
			}, () => {
				this.translateService.transform("NoAccessibilityStatementFound" + MESSAGE_SUFFIX).pipe(takeUntilDestroy(this)).subscribe((translation: string) => {
					this.statement = translation;
					this.changeDetector.markForCheck()
				}, (error) => {
					LogManager.debug(LogCat.SelfScheduling.General, "Unknown error", error);
					this.commonService.showErrorNotification("UnknownError");
				});
			});
		});
	}

	ngOnDestroy(): void {

	}
}
